import React, { useEffect, useState } from 'react';
import { recoveryFacts, RECOVERY_REASONS, RECOVERY_OUTCOMES } from '../../utils/wirelessDebuggingRecovery';

export function useRecoveryFacts(observation) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const remaining = observation?.expiresAtEpochMs - Date.now();
    if (!(remaining > 0 && remaining <= 60000)) return undefined;
    const timer = setTimeout(() => setTick((tick) => tick + 1), remaining + 1);
    return () => clearTimeout(timer);
  }, [observation?.expiresAtEpochMs]);
  return recoveryFacts(observation);
}

export default function WirelessDebuggingRecoveryStatus({ observation, compact = false }) {
  const facts = useRecoveryFacts(observation);
  if (compact) return <span className={`topology-live__signal ${facts.fresh && facts.setup === 'Configured' ? 'is-good' : 'is-muted'}`}
    title={`Recovery setup: ${facts.setup}. Local debugging: ${facts.debugging}. ADB reachability is shown separately.`}>
    Recovery: {facts.setup} · Local debugging: {facts.debugging}
  </span>;
  return <div className="device-config__recovery-status" aria-label="Target recovery observation">
    <p>Recovery setup: <strong>{facts.setup}</strong></p>
    <p>Permission: {facts.permission} · Local debugging: {facts.debugging}</p>
    {observation?.observedAt && <p>Target observed {new Date(observation.observedAt).toLocaleString()}{!facts.fresh ? ' · stale' : ''}</p>}
    {facts.fresh && RECOVERY_OUTCOMES[observation.lastOutcome] && <p>Last local outcome: {RECOVERY_OUTCOMES[observation.lastOutcome]}
      {observation.lastOutcomeAt ? ` (${new Date(observation.lastOutcomeAt).toLocaleTimeString()})` : ''}</p>}
    {facts.fresh && observation.monitorIssues?.length > 0 && <p>Some recovery monitoring is unavailable on this target.</p>}
  </div>;
}

export function WirelessDebuggingRecoveryResult({ result, enabled, status }) {
  const verified = ['applied', 'already_set'].includes(result?.status) && result?.activationStatus === 'verified'
    && result.recoveryEnabled === enabled && (!enabled || (result.permissionGranted === true && result.monitorRunning === true));
  return <div aria-label="Saved recovery setup result">
    {verified ? <p>{enabled ? 'Recovery configured and verified.' : 'Recovery disabled and verified.'}</p>
      : status !== 'queued' && status !== 'running' && <p>Recovery setup is incomplete. See the separate permission and activation results.</p>}
    {result && <>
      <p>Permission grant: {({ granted: 'Granted and verified', already_granted: 'Already granted and verified',
        failed: 'Failed', unverified: 'Not verified', not_attempted: 'Not attempted' })[result.permissionStatus] || 'Unknown'}</p>
      <p>Recovery activation: {({ verified: 'Verified', failed: 'Failed', unverified: 'Not verified', not_attempted: 'Not attempted' })[result.activationStatus] || 'Unknown'}</p>
      {RECOVERY_REASONS[result.reason] && <p>{RECOVERY_REASONS[result.reason]}</p>}
    </>}
    <p>This is the saved setup result. Current local observations and ADB reachability are shown separately.</p>
  </div>;
}
